<template>
  <span v-if="lift.path">
    <a v-if="lift.is_redirectable" :href="lift.url" target="_blank" rel="noreferrer">
      <span class="text-none" v-html="title"></span>
    </a>

    <router-link v-else flat :to="{ path: lift.path}">
      <span class="text-none" v-html="title"></span>
    </router-link>
  </span>
  <span v-else class="text-none" v-html="title"></span>
</template>

<script>
export default {
  props: ["lift"],

  computed: {
    title() {
      return this.getLocalizedText("title");
    }
  },
  methods: {
    getLocalizedText(item) {
      if (
        typeof this.lift[item] === "string" ||
        this.lift[item] instanceof String
      ) {
        return this.lift[item];
      }

      console.log("getLocalizedText TopBarLift", this.lift);

      // If text has localized
      const localizedText = this.lift[item][this.$i18n.locale];
      if (localizedText) return localizedText;

      // If not localized title return fallback
      switch (this.$i18n.locale) {
        case "en":
          return this.lift[item]["fi"] || this.lift[item]["se"];
        case "fi":
          return this.lift[item]["en"] || this.lift[item]["se"];
        case "se":
          return this.lift[item]["en"] || this.lift[item]["fi"];
      }

      return null;
    }
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: none;
}
</style>